export default __webpack_public_path__ + "static/media/AddIcon.214ee7f7.svg";